import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

import { ISanityTextNode } from '@rbi-ctg/menu';
import { useFeatureDepositPriceExclusionQuery } from 'generated/sanity-graphql';

interface IDepositContext {
  depositExclusionModifierIds?: Record<string, true>;
  depositExclusion?: {
    depositText?: {
      depositInfoText?: {
        depositInfoHomeDeliveryText?: ISanityTextNode;
        depositInfoPickupText?: ISanityTextNode;
      };
    };
  };
}

const defaultContext: IDepositContext = {
  depositExclusionModifierIds: {},
  depositExclusion: {},
};

const DepositContext = createContext<IDepositContext>(defaultContext);

export const useDepositContext = () => useContext(DepositContext);

export const DepositContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data: depositExclusionData } = useFeatureDepositPriceExclusionQuery({
    variables: { id: 'depositPriceExclusion' },
  });

  const [depositExclusionModifierIds, setDepositExclusionModifierIds] =
    useState<Record<string, true>>();
  const [depositExclusion, setDepositExclusion] = useState({});
  useEffect(() => {
    const excludedIdsArray =
      depositExclusionData?.DepositPriceExclusion?.excludeDepositFromItemPriceCalculation ?? [];

    setDepositExclusion({
      depositText: depositExclusionData?.DepositPriceExclusion,
    });

    const excludedIdsMap = excludedIdsArray.reduce<Record<string, true>>((acc, item) => {
      if (item?._id) {
        acc[item._id] = true;
      }
      return acc;
    }, {});
    setDepositExclusionModifierIds(excludedIdsMap);
  }, [depositExclusionData]);

  const depositContextData = useMemo(() => {
    return { depositExclusionModifierIds, depositExclusion };
  }, [depositExclusionModifierIds, depositExclusion]);

  return <DepositContext.Provider value={depositContextData}>{children}</DepositContext.Provider>;
};
